module.exports = __webpack_public_path__ + "img/avatar_female.922ccf5b.jpg";